import { Component } from 'preact'
import Header from '../../header'
import AlertComponent from '../../ui-components/AlertComponent'
import Panel from '../../panel'
import InputGroup from '../../ui-components/InputGroup'
import Attachments from './Attachments'
import axios from 'axios'

class ParentCategoryAdd extends Component {
  constructor (props) {
    super()
    this.state = {
      messageType: null,
      errors: [],
      category: props.category,
      showModal: false,
      showConfirmation: false,
      showError: false,
      successMessage: ''
    }
    this.saveCategory = this.saveCategory.bind(this)
    this.setValue = this.setValue.bind(this)
  }

  saveCategory () {
    const newData = JSON.parse(JSON.stringify(this.state.category))
    let errors = []

    if (!newData.title || newData.title === '') {
      errors.push('title')
    }
    if (!newData.description || newData.description === '') {
      errors.push('description')
    }
    if (errors.length) {
      this.setState({ errors })
      return
    }

    axios.post('/settings/category/new', newData)
      .then(() => {
        this.setState({ messageType: 'success' })
        window.location.assign(this.props.overviewLink)
      })
      .catch(() => {
        this.setState({ messageType: 'error' })
      })
  }

  setValue (key, value) {
    const category = Object.assign({}, this.state.category, { [key]: value })
    this.setState({ category, errors: [] })
  }

  render (props, state) {
    return (
      <div className='category-add_container'>
        <Header
          title={props.pageTitle}
          disableCancelButton
          disableSaveButton
          customButtons={[
            <div
              className='btn btn-cancel js-cancel'
              onClick={() => { window.location.assign(props.overviewLink) }}>
              Cancel
            </div>,
            <div
              className='btn btn-success js-submit'
              onClick={this.saveCategory}>
              Save
            </div>]}
        />
        <AlertComponent messageType={state.messageType} />
        <Panel title='Details'>
          <form>
            <InputGroup
              title='Title'
              placeholder='Add a title'
              type='text'
              error={state.errors.indexOf('title') !== -1 ? 'Please fill in this field' : ''}
              onChange={(e) => this.setValue('title', e.target.value)}
              value={state.category.title} />
            <InputGroup
              title='Description'
              placeholder='Add a description'
              error={state.errors.indexOf('description') !== -1 ? 'Please fill in this field' : ''}
              type='text'
              onChange={(e) => this.setValue('description', e.target.value)}
              value={state.category.description} />
            <div className='form-group show_description'>
              <input
                type='checkbox'
                name='show_description'
                id='show_description'
                checked={state.category.showDescriptionOnHomepage}
                onChange={() => this.setValue('showDescriptionOnHomepage', !state.category.showDescriptionOnHomepage)} />
              <label htmlFor='show_description'>Show description in category list on homepage.</label>
            </div>
            <Attachments
              label='Hero image'
              className='hero-image'
              meta={
                <div>
                  <div>Hero image will be shown on top of the category page.</div>
                  <div>Maximum file size: 5MB. Allowed image types: .jpg, .png, .gif. We recommend a minimum of 2880*480px</div>
                </div>
              }
              isAttachmentSelected={state.category.heroImage}
              imageSrc={state.category.heroImage && state.category.heroImage.source_thumb}
              width={2880}
              height={480}
              onUpdate={(data) => this.setValue('heroImage', data)}
            />
          </form>
        </Panel>
      </div>
    )
  }
}

export default ParentCategoryAdd
